import { render, staticRenderFns } from "./el-estate-sub-type-select.vue?vue&type=template&id=2208b42a&scoped=true&"
import script from "./el-estate-sub-type-select.vue?vue&type=script&lang=js&"
export * from "./el-estate-sub-type-select.vue?vue&type=script&lang=js&"
import style0 from "./el-estate-sub-type-select.vue?vue&type=style&index=0&id=2208b42a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208b42a",
  null
  
)

export default component.exports